<template>
  <b-modal
    class="text-left"
    ref="requestModal"
    :title="$t('order.requestQuestion', { projectNumber })"
  >
    <span>
      <p>{{$t("order.requestMessage")}}<br>{{$t("order.requestInfo")}}</p>
    </span>
    <span>
      <template>
        <div>
          <b-form-textarea
            id="textarea"
            v-model="text"
            rows="3"
            autofocus
            maxlength="500"
            max-rows="6"
            no-resize
          ></b-form-textarea>
        </div>
      </template>
    </span>

    <b-alert v-if="invalidConfiguration" class="mt-4" variant="danger" show>
      {{ $t('order.errorInConfiguration', [invalidConfiguration.configurationName]) }}
    </b-alert>

    <template slot="modal-footer">
      <b-button @click="$refs.requestModal.hide()">{{$t('cancel')}}</b-button>
      <b-button autofocus class="send-button" @click="requestButtonClicked()" :disabled="loadingValidation || invalidConfiguration != null">{{$t('order.send')}}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      text: ""
    };
  },

  computed: {
    projectNumber() {
      return this.$store.getters.projectNumber
    },
    invalidConfiguration() {
      if (this.$store.state.projects.projectValidation == null) return null;
      if (this.$store.state.projects.projectValidation.status == "ok") return null;
      const result = this.$store.state.projects.projectValidation

      return this.$store.state.configurations.configurationAmounts[result.configurationIndex].configuration
    },
    loadingValidation() {
      return this.$store.state.projects.loadingProjectValidation;
    }
  },

  methods: {
    show() {
      this.$refs.requestModal.show();
      this.$store.dispatch("projects/validate");
    },
    async requestButtonClicked() {
      await this.$store.dispatch("projects/requestProject", {
        message: this.text
      });
      this.$refs.requestModal.hide();
    }
  }
};
</script>

<style scoped>
.send-button {
  color: #fff;
  background-color: #00a0e4;
  border-color: #00a0e4;
}
</style>
